import { createSlice } from '@reduxjs/toolkit';

interface CurrentTab {
    salaryCalculationId: string;
    departmentIds: any;
}

const initialState: CurrentTab = {
    salaryCalculationId: '',
    departmentIds: null
}

export const salaryCalculationSlice = createSlice({
    name: 'salaryCalculation',
    initialState,
    reducers: {
        updateSalaryCalculationId: (state, { payload }) => {
            state.salaryCalculationId = payload
        },
        updateDepartmentIds: (state, { payload }) => {
            state.departmentIds = payload
        },
    },
})

export const { updateSalaryCalculationId, updateDepartmentIds } = salaryCalculationSlice.actions

export default salaryCalculationSlice.reducer